<section class="reason-catalogs" aria-labelledby="reason-catalogs-title">
  <header>
    <div>
      <h2 id="reason-catalogs-title">Reason catalogs</h2>
      <p>
        Manage base reasons for registered timer commands. Draft changes take
        effect only through the existing configuration publication and command
        setup.
      </p>
    </div>
    <button
      uiButton
      type="button"
      (click)="load()"
      [disabled]="loading || draftState.isNavigationBlocked() || !canRead()"
    >
      Refresh catalogs
    </button>
  </header>
  <p *ngIf="!canRead() || accessLost" role="alert">
    Reason catalogs are unavailable with your current access.
  </p>
  <ng-container *ngIf="canRead() && !accessLost">
    <div class="catalog-controls">
      <label
        >Command<select
          uiControl
          [ngModel]="domainCode"
          (ngModelChange)="chooseDomain($event)"
          [disabled]="loading || draftState.isNavigationBlocked()"
        >
          <option *ngFor="let domain of domains" [value]="domain.domainCode">
            {{ domain.label }}
          </option>
        </select></label
      >
      <label
        >Configuration version<select
          uiControl
          [ngModel]="versionId"
          (ngModelChange)="chooseVersion($event)"
          [disabled]="loading || draftState.isNavigationBlocked()"
        >
          <option value="">All configuration versions</option>
          <option *ngFor="let version of versions()" [value]="'' + version.id">
            {{ versionLabel(version) }}
          </option>
        </select></label
      >
      <button
        uiButton
        type="button"
        (click)="create()"
        [disabled]="!editable() || draftState.isNavigationBlocked()"
      >
        New reason
      </button>
    </div>
    <p *ngIf="loading" role="status">Loading reason catalogs…</p>
    <p *ngIf="error" role="alert">{{ error }}</p>
    <p *ngIf="notice" role="status">{{ notice }}</p>
    <ng-container *ngIf="detail">
      <p *ngIf="!versionId">
        Choose a draft configuration version to add a reason, or open an
        existing entry.
      </p>
      <p *ngIf="selectedVersion() as version" class="version-context">
        {{ versionLabel(version) }} · Base values: global · Effective
        {{ version.effectiveStartUtc | date: "medium"
        }}<span *ngIf="version.effectiveEndUtc">
          until {{ version.effectiveEndUtc | date: "medium" }}</span
        >. Agency overrides are managed separately.
      </p>
      <ui-grid
        [rowData]="entries()"
        [columnDefs]="columns"
        [agGridOptions]="gridOptions"
        [showPanelHeader]="false"
        [showBlankRowsOnLastPage]="false"
        [autoHidePaginator]="true"
        noDataFoundMessage="No base reasons exist in this selection."
      />
    </ng-container>
    <form
      *ngIf="editing"
      (ngSubmit)="save()"
      class="reason-editor"
      aria-label="Reason entry"
    >
      <h3>{{ selectedEntry ? "Reason entry" : "New reason" }}</h3>
      <p *ngIf="selectedVersion()?.statusCode !== 'draft'">
        This published or retired version is read-only. Select a draft to author
        changes.
      </p>
      <fieldset [disabled]="!editable() || draftState.busy()">
        <label
          >Code<input
            uiControl
            name="reasonCode"
            [(ngModel)]="values.code"
            (ngModelChange)="changed()"
            maxlength="120" /></label
        ><label
          >Reason label<input
            uiControl
            name="reasonLabel"
            [(ngModel)]="values.displayText"
            (ngModelChange)="changed()"
            maxlength="200" /></label
        ><label class="enabled"
          ><input
            type="checkbox"
            name="enabled"
            [(ngModel)]="values.isActive"
            (ngModelChange)="changed()"
          />
          Enabled</label
        ><label
          >Order<input
            uiControl
            type="number"
            name="order"
            [(ngModel)]="values.sortOrder"
            (ngModelChange)="changed()"
            min="0"
            step="1"
        /></label>
      </fieldset>
      <p *ngIf="stale" role="status">
        The catalog changed. Discard these edits and refresh before trying
        again.
      </p>
      <div class="editor-actions">
        <button
          uiButton
          type="submit"
          [disabled]="!editable() || draftState.busy()"
        >
          {{ draftState.busy() ? "Saving…" : "Save draft reason" }}</button
        ><button
          uiButton
          type="button"
          (click)="reset()"
          [disabled]="draftState.busy()"
        >
          Discard edits
        </button>
      </div>
    </form>
  </ng-container>
</section>
